import React from 'react';
import { formatCurrency } from '@avila-tek/ui/src';

interface ProductItemProps {
  title: string;
  subtitle: string;
  quantity: number;
  price: number;
}

function ProductItem({ title, subtitle, quantity, price }: ProductItemProps) {
  return (
    <div className="w-full border-t border-system-500 flex py-3 text-text-gray">
      <div>{quantity} x</div>
      <div className="flex flex-col pl-2">
        <span className="text-text-black font-semibold">{title}</span>
        <span>{subtitle}</span>
      </div>
      <div className="ml-auto">
        <span>
          {quantity} x $ {formatCurrency(price)}
        </span>
      </div>
    </div>
  );
}

export default ProductItem;
